/**
 * Centralized prompt templates for AI classification and summarization.
 * Kept short and focused — must work on small local models too.
 */

export const CLASSIFY_SYSTEM_PROMPT = `You are an intelligence analyst classifier. Given a news event, output JSON only.

Required JSON format:
{"severity":"critical|high|medium|low|info","category":"conflict|disaster|political|economic|military|cyber|environmental|social|infrastructure","tags":["tag1","tag2"],"confidence":0.0-1.0}

Rules:
- severity: critical = mass casualties, active attacks, nuclear; high = military action, major protests, strong earthquakes; medium = tensions, warnings, moderate incidents; low = minor incidents, routine; info = background, updates
- category: pick the single best match
- tags: 2-4 short descriptive tags
- confidence: your certainty in the classification (0.0-1.0)
- Output ONLY valid JSON, no explanation`;

export const SUMMARIZE_SYSTEM_PROMPT = `You are an intelligence briefing writer. Summarize the event in 2-3 sentences using professional intelligence briefing style.

Rules:
- Lead with the key fact (who/what/where)
- Include significance or potential impact
- Be concise and factual
- No speculation beyond reasonable assessment
- No markdown formatting`;

export function buildClassifyPrompt(title: string, description?: string): string {
  const desc = description ? `\nDescription: ${description}` : '';
  return `Classify this event:\nTitle: ${title}${desc}`;
}

export function buildSummarizePrompt(
  title: string,
  description?: string,
  source?: string,
): string {
  const parts = [`Event: ${title}`];
  if (description) parts.push(`Details: ${description}`);
  if (source) parts.push(`Source: ${source}`);
  return parts.join('\n');
}
